import { FieldError, FieldErrors } from "react-hook-form";

export const getNestedFieldError = (
  errors: FieldErrors,
  fieldPath: string
): FieldError | undefined => {
  const parts = fieldPath.split(".");
  let current: unknown = errors;
  for (const part of parts) {
    if (!current || typeof current !== "object") return undefined;
    current = (current as Record<string, unknown>)[part];
  }
  return current as FieldError | undefined;
};

export const getNestedFieldErrors = (
  errors: FieldErrors,
  fieldPrefix: string
): FieldErrors | undefined => {
  const parts = fieldPrefix.split(".");
  let current: unknown = errors;
  for (const part of parts) {
    if (!current || typeof current !== "object") return undefined;
    current = (current as Record<string, unknown>)[part];
  }
  return current as FieldErrors | undefined;
};
